import { userConstants } from "../_constants";

let token = JSON.parse(localStorage.getItem("token"));
const initialState = token ? { loggedIn: true, token } : { loggedIn: false };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        token: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        token: action.user,
      };
    case userConstants.LOGIN_FAILURE:
      return { loggedIn: false };
    case userConstants.LOGOUT:
      return { loggedIn: false };
    case userConstants.GET_GEO_LOCATION:
      return { ...state, geoLocation: action.payload };
    default:
      return state;
  }
}
